"use strict";

require("angular");

require("angular-animate");

require("angular-cookies");

require("angular-sanitize");

require("angular-ui-bootstrap");

require("angular-ui-router");

require("angular-ui-switch");

require("ng-infinite-scroll");

require("angular-translate");

require("angular-translate-loader-static-files");

require("angular-translate-storage-cookie");

require("angular-translate-storage-local");

require("moment");

require("moment-duration-format");

require("clipboard");

require("lru-cache");

require("lodash");

require("node-uuid");

require("turf");

require("papaparse");

require("file-saver");

require("ui-select");

require("ui-select/dist/select.css");

require("angular-ui-switch/angular-ui-switch.css");

require("./css/bootstrap/bootstrap.css");

require("./js/vendor/angular-translate-handler-log/angular-translate-handler-log.js");

require("./js/vendor/angular-dynamic-locale/dist/tmhDynamicLocale.js");

require("./js/vendor/ui-utils.min.js");

require("./js/vendor/angular-visibility-change.min.js");


// WEBPACK FOOTER //
// ./vendor.js